import { PartialType } from '../../../utils';
import { CreateBlackListDto } from './create-black-list.dto';
export class UpdateBlackListDto extends PartialType(CreateBlackListDto) {
}
